import React, { Component } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Slide } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from 'styled-components/macro';
import { withStyles } from "@material-ui/core/styles";

import RefiCashoutModal from './RefiCashoutModal';

const localStyles = () => ({
  dialogPaper: {
    'min-width': '1200px',
    'font-size': '13px'
  },
  dialogTitle: {
    color: 'blue',
    padding: '0 0 0 20px'
  }
});

const StyledDialog = styled(Dialog)`
&&&{
  min-width: 700px;
}
`
const StyledDialogContent = styled(DialogContent)`
  && {
    color: #666;
    min-height: 450px;
    min-width:700px;
  }
`;

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

export function Transition(props) {
  return <Slide direction="up" {
    ...props
  }
  />;
}

class ModalForm extends Component {
  state = {}

  render() {
    const { isOpen, handleClose, dealId, classes } = this.props;
    return (
      <StyledDialog
        modal={true}
        fullWidth maxWidth="md"
        open={isOpen}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        classes={{ paper: classes.dialogPaper }}
        contentStyle={{ width: "700px", maxWidth: "none" }}>

        <DialogTitle id="form-dialog-title">
          Refi Cash Out
          <StyledDialogIconButton onClick={handleClose}>
            <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
          </StyledDialogIconButton>
        </DialogTitle>

        <StyledDialogContent>
          <RefiCashoutModal dealId={dealId} pageOrientation="modal" />
        </StyledDialogContent>
      </StyledDialog>)
  }
}


export default withStyles(localStyles)(ModalForm);
